import { useTranslation } from 'react-i18next';
import { StockHistoryResponseDto } from '@tiendanube/common';
import { Domain } from '@tiendanube/common/src/enums';

function useLocationLabel(stockHistory: StockHistoryResponseDto) {
  const { t } = useTranslation(Domain.CATALOG);

  const labelDeletedLocation = t(
    'products.stockHistoryModal.labelLocation.deleted',
  );

  let locationLabel = stockHistory.locationId
    ? t('products.stockHistoryModal.labelLocation.inLocation', {
        locationName: stockHistory.locationName ?? labelDeletedLocation,
      })
    : '';

  if (
    stockHistory.reason === 'stockTransferIn' ||
    stockHistory.reason === 'stockTransferOut'
  ) {
    const stockTransferFromTo =
      stockHistory.reason === 'stockTransferIn' ? 'fromLocation' : 'toLocation';

    locationLabel = t(
      `products.stockHistoryModal.labelLocation.${stockTransferFromTo}`,
      {
        locationName: stockHistory.relatedLocationName ?? labelDeletedLocation,
      },
    );
  }

  return locationLabel;
}

export default useLocationLabel;
